import { useCallback, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { alertActive, alertError, alertSuccess } from "../../../components/alert/swal";
import { ComplaintPublishStatus, COMPLAINTS_FILE_TYPE, COMPLAINTS_STATUS, COMPLAINTS_STATUS_DATA, status_not_receive_check } from "./enum/complaint.enum";
import { complaintType, ComplaintTypeApi } from "../../../api/complaint-type/complaint_type.api";
import { ComplaintApi, complaintCreateFront, logComplaintType, meetingComplaints, updateStatusBack } from "../../../api/complaint/complaint.api";
import { routeName } from "../../../routes/routeName";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { mimeTypes } from "../../../constants/enum";
import { useMediaQuery, useTheme } from "@mui/material";
import moment from "moment";
import TableRowCommon from "../../../components/table/TableRowCommon";
import StatusCustom from "../../../components/status/statusCustom";
import { saveAs } from "file-saver";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import { useTranslation } from "react-i18next";

type complaintSubmitFormState = {
    id_group: number | null,
    complaint_title: string;
    complaint_detail: string;
    is_publish: boolean;
    first_name: string;
    first_name_eng: string;
    last_name: string;
    last_name_eng: string;
    phone_number: string;
    email: string;
    id_card: string;
    employee_no: string;
    id_faculty: number;
    id_student: number;
    faculty: any;
    // id_position: number;
}
export const ManageStateComplaintSubmitDetail = () => {
    const { id } = useParams();
    const { t } = useTranslation();
    const profile = useSelector((state: any) => state?.profile?.profile);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    // console.log(profile, 'profile')

    const [step, set_step] = useState<number>(0);
    const [formState, setFormState] = useState<complaintSubmitFormState>({
        id_group: 1,
        complaint_title: "",
        complaint_detail: "",
        is_publish: true,
        first_name: "",
        first_name_eng: "",
        last_name: "",
        last_name_eng: "",
        phone_number: "",
        email: "",
        id_card: "",
        employee_no: "",
        id_faculty: 0,
        id_student: 0,
        faculty: null
        // id_position: 0
    })
    const [image_data, set_image_data] = useState<any[]>([]);
    const [complaints_files, set_complaints_files] = useState<any[]>([]);
    const [group_data, set_group_data] = useState<any[]>([]);
    const [status, set_status] = useState<string>(COMPLAINTS_STATUS.DRAFT);
    const [search_complaint_type, set_search_complaint_type] = useState<string>("");
    const [complaint_data_old, set_complaint_data_old] = useState<any[]>([]);
    const [complaint_type_data, set_complaint_type_data] = useState<any[]>([]);
    const [id_complaints_type, set_id_complaints_type] = useState<any>(null);
    const [show_time_line, set_show_time_line] = useState<string>("");
    const [dataDetail, setDataDetail] = useState<any>(null);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [data_time_line, set_data_time_line] = useState<any[]>([]);

    const [dataMeeting, setDataMeeting] = useState<any[]>([]);
    const [pageMeeting, setPageMeeting] = useState<number>(1);
    const [pageLimitMeeting, setPageLimitMeeting] = useState<number>(10);
    const [totalItemsMeeting, setTotalItemsMeeting] = useState<number>(0);
    const [sortByMeeting, setSortByMeeting] = useState<string>("modified_date");
    const [sortTypeMeeting, setSortTypeMeeting] = useState<string>("DESC");

    const [file_infer, set_file_infer] = useState<any[]>([]);
    const [file_infer_api, set_file_infer_api] = useState<any[]>([]);

    const [remark, set_remark] = useState<string>("");


    const handleOpenModal = (mode: string) => {
        set_show_time_line(mode);
    }
    const handleCloseModal = () => {
        setPage(1);
        setPageLimit(10);
        set_show_time_line("");
        set_file_infer([]);
        set_remark("");
    }
    const handleChangeFormState = (field: string, value: any) => {
        setFormState((prev) => ({ ...prev, [field]: value }))
    }
    const handleChangeImage = (newFile: any) => {
        const newArray = Array.isArray(newFile) ? newFile : [newFile];
        if (newFile?.length > 0) {
            set_image_data((prev) => ([...prev, ...newArray]));
        } else {
            set_image_data((prev) => ([...prev, newFile]));
        }
    };
    const handleChangeImageInfer = (newFile: any) => {
        const newArray = Array.isArray(newFile) ? newFile : [newFile];
        if (newFile?.length > 0) {
            set_file_infer((prev) => ([...prev, ...newArray]));
        } else {
            set_file_infer((prev) => ([...prev, newFile]));
        }
    };



    const handleGetData = (id: string | undefined) => {
        if (!id && profile) {
            setFormState((prev) => ({
                ...prev,
                first_name: profile?.first_name || profile?.student_frist_name || "",
                first_name_eng: profile?.first_name_eng || "",
                last_name: profile?.last_name || profile?.student_last_name || "",
                last_name_eng: profile?.last_name_eng || "",
                phone_number: profile?.phone_number || profile?.phone || "",
                email: profile?.email_personal || profile?.student_email || "",
                id_card: profile?.idcard || "",
                employee_no: profile?.employee_no || profile?.student_no || "",
                id_faculty: profile?.id_faculty || null,
                id_student: profile?.id_student,
                // id_position: profile?.id_position || null
            }))
        }
    }
    const handleGetComplaintType = useCallback(async () => {
        let query: complaintType = {
            page: 1,
            limit: 20
        }
        if (search_complaint_type) query = { ...query, keyword: search_complaint_type }
        await ComplaintTypeApi.getList(query).then((res) => {
            if (res.status < 300) {
                set_complaint_type_data(res.data?.data?.items || [])
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [search_complaint_type])

    const handleGetFile = async (index: number) => {
        const id_complaints_file = complaint_data_old?.find((_, i) => i === index)?.id_complaints_file
        const file_type = complaint_data_old?.find((_, i) => i === index)?.file_type;
        const file_type_case = mimeTypes[file_type] || 'application/octet-stream';
        dispatch(setLoading());
        await ComplaintApi.downloadFile(id_complaints_file).then((res) => {
            if (res.status < 300) {
                const blob_file = new Blob([res.data], { type: file_type_case })
                const url = URL.createObjectURL(blob_file);
                window.open(url, '_blank')
            }
        }).catch((err) => {
            throw err
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleGetDetail = async (id_complaints: number) => {
        dispatch(setLoading());
        await ComplaintApi.getOne(id_complaints).then(async (res) => {
            if (res.status < 300) {
                const data = res.data?.data;
                const complaints_files_data = data?.complaints_files?.filter((x: any) => x?.complaints_file_type === COMPLAINTS_FILE_TYPE.ATTACH_FILE)?.map(async (list: any) => {
                    return await ComplaintApi.downloadFile(list?.id_complaints_file).then((res) => {
                        // console.log(res.headers["content-type"],'res.headers["content-type"];')
                        return { id_complaints_file: list?.id_complaints_file, file: new File([res.data], list?.file_name, { type: list?.file_type }) };
                    }).catch((err) => {
                        console.log(err);
                        return [];
                    })
                })
                const complaints_files_data_infer = data?.complaints_files?.filter((x: any) => x?.complaints_file_type === COMPLAINTS_FILE_TYPE.SUMMARY_FILE)?.map(async (list: any) => {
                    return await ComplaintApi.downloadFile(list?.id_complaints_file).then((res) => {
                        // console.log(res.headers["content-type"],'res.headers["content-type"];')
                        return { id_complaints_file: list?.id_complaints_file, file: new File([res.data], list?.file_name, { type: list?.file_type }) };
                    }).catch((err) => {
                        console.log(err)
                        return [];
                    })
                })
                const promise_file = await Promise.all(complaints_files_data || [])
                const promise_file_infer = await Promise.all(complaints_files_data_infer || [])
                setDataDetail(data);
                set_complaint_data_old(data?.complaints_files?.filter((x: any) => x?.complaints_file_type === COMPLAINTS_FILE_TYPE.ATTACH_FILE) || []);
                set_file_infer_api(promise_file_infer);
                set_id_complaints_type(data?.complaints_type);
                set_complaints_files(promise_file || []);
                set_status(data?.complaints_status || "");
                setFormState((prev) => ({
                    ...prev,
                    complaint_title: data?.complaints_subject || "",
                    complaint_detail: data?.complaints_desc || "",
                    is_publish: data?.is_public,
                    first_name: data?.first_name || "",
                    last_name: data?.last_name || "",
                    id_student: data?.id_student,
                    employee_no: data?.student_no || "",
                    id_card: data?.passport || "",
                    id_faculty: data?.id_faculty,
                    faculty: data?.faculty,
                    email: data?.email || "",
                    phone_number: data?.phone || ""
                }))
            }
        }).catch((err) => {
            throw err
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleDeleteImageApi = (index: number) => {
        set_complaints_files((prev) => prev.filter((_, i) => i !== index));
    }
    const handleDeleteImageUploadFile = (index: number) => {
        set_image_data((prev) => prev.filter((_, i) => i !== index))
    }
    const handleDeleteImageUploadFileInfer = (index: number) => {
        set_file_infer((prev) => prev.filter((_, i) => i !== index))
    }
    const handleUploadImageFile = async (id_complaints: number) => {
        if (image_data.length > 0) {
            dispatch(setLoading());
            await Promise.all(image_data.map(async (list) => {
                const formData = new FormData();
                formData.append('file', list?.file);
                formData.append('id_complaints', `${id_complaints}`);
                formData.append('complaints_file_type', COMPLAINTS_FILE_TYPE.ATTACH_FILE);
                await ComplaintApi.uploadFile(formData).then((res) => {
                    if (res.status > 300) {
                        alertError(t("COMPLAINTS_UPLOAD_FILE"), t("COMPLAINTS_UPLOAD_FAILED"))
                    }
                }).catch((err) => {
                    // throw err
                    alertError(t("COMPLAINTS_UPLOAD_FAILED"), err?.response?.data?.message || "อัพโหลดไฟล์ ไม่สำเร็จ")
                })
            }))
            dispatch(unsetLoading());
        }
    }
    const handleUploadImageFileInfer = async (id_complaints: number) => {
        if (file_infer.length > 0) {
            dispatch(setLoading());
            await Promise.all(file_infer.map(async (list) => {
                const formData = new FormData();
                formData.append('file', list?.file);
                formData.append('id_complaints', `${id_complaints}`);
                formData.append('complaints_file_type', COMPLAINTS_FILE_TYPE.SUMMARY_FILE);
                await ComplaintApi.uploadFile(formData).then((res) => {
                    if (res.status > 300) {
                        alertError(t("COMPLAINTS_UPLOAD_FILE"), t("COMPLAINTS_UPLOAD_FAILED"))
                    }
                }).catch((err) => {
                    // throw err
                    alertError(t("COMPLAINTS_UPLOAD_FAILED"), err?.response?.data?.message || "อัพโหลดไฟล์ ไม่สำเร็จ")
                })
            }))
            dispatch(unsetLoading());
        }
    }
    const handleDeleteFile = async () => {
        try {
            const file_delete = complaint_data_old.filter((x) => complaints_files.every((e) => e?.id_complaints_file !== x?.id_complaints_file));
            dispatch(setLoading());
            const promise_data = file_delete.map(async (list) => {
                await ComplaintApi.deleteFile(list?.id_complaints_file).catch((err) => console.log(err))
            })
            await Promise.all(promise_data);
            dispatch(unsetLoading());
        } catch (err) {
            console.log(err)
        }
    }
    const handleDownloadFile = async (id_complaints_file: number, file_type: string, file_name: string) => {
        try {
            dispatch(setLoading());
            await ComplaintApi.downloadFile(id_complaints_file).then((res) => {
                if (res.status < 300) {
                    const data = res.data;
                    const blob_file = new Blob([data], { type: file_type })
                    saveAs(blob_file, file_name)
                }
            }).catch((err) => {
                console.log(err);
                alertError(t("COMPLAINTS_DOWNLOAD_FILE"), t("COMPLAINTS_DOWNLOAD_FAILED"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } catch (err) {
            console.log(err)
        }
    }

    // TIMELINE
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "subject_no", width: 60, disablePadding: false, align: 'center', label: t("COMPLAINTS_ORDER")
        },
        {
            id: "subject_name", disablePadding: false, width: 100, align: "center", label: t("COMPLAINTS_DATE")
        },
        {
            id: "subject", disablePadding: false, align: "center", width: 80, label: t("COMPLAINTS_TIME")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 120, label: t("COMPLAINTS_STATUS")
        },
        {
            id: "subject_detail", disablePadding: false, align: "center", width: 140, label: t("COMPLAINTS_DESCRIPTION")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("COMPLAINTS_HANDLER")
        },
    ];
    const renderData = (objData: any, a: any) => {
        a = page * pageLimit - pageLimit + a + 1
        const {
            no,
            complaints_log_date,
            complaints_status,
            remark,
            submit_full_name
        } = objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                { option: "TEXT", align: "center", label: complaints_log_date ? moment(complaints_log_date).add(543, 'year').format("DD/MM/YYYY") : "-" },
                {
                    option: "TEXT",
                    align: "center",
                    label: complaints_log_date ? moment(complaints_log_date).format("HH:mm") : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: <StatusCustom
                        disableMaxWidth
                        text={COMPLAINTS_STATUS_DATA.find((x) => x.value === complaints_status)?.label || ""}
                        type={COMPLAINTS_STATUS_DATA.find((x) => x.value === complaints_status)?.label || ""}
                    />
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: remark || "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: submit_full_name || "-"
                },

            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };
    const handleRequestSortMeeting = (sortBy: string, sortType: string) => {
        setSortByMeeting(sortBy)
        setSortTypeMeeting(sortType)
    }

    const headCellsMeeting = [
        {
            id: "subject_no", width: 60, disablePadding: false, align: 'center', label: t("COMPLAINTS_ORDER")
        },
        {
            id: "subject_name", disablePadding: false, width: 100, align: "center", label: t("COMPLAINTS_MEETING_NAME")
        },
        {
            id: "subject", disablePadding: false, align: "center", width: 80, label: t("COMPLAINTS_CHAIRPERSON")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 120, label: t("COMPLAINTS_DATE_TIME")
        },
        {
            id: "ac", disablePadding: false, align: "center", class: matches && dataMeeting?.length > 0, width: 50, label: ""
        },
    ];
    const renderDataMeeting = (objData: any, a: any) => {
        a = page * pageLimit - pageLimit + a + 1
        const {
            no,
            id_meeting_room,
            meeting_room_name,
            principal_full_name,
            meeting_room_start_date,
            meeting_room_end_date,
            meeting_room_end_time,
            meeting_room_start_time
        } = objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: meeting_room_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: principal_full_name || "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: `${meeting_room_start_date ? moment(meeting_room_start_date).format("DD/MM/YYYY") : ""} - 
                    ${meeting_room_end_date ? moment(meeting_room_end_date).format("DD/MM/YYYY") : ""}
                    ${meeting_room_start_time ? moment(meeting_room_start_time).format("HH:mm") + "-" : ""}
                    ${meeting_room_end_time ? moment(meeting_room_end_time).format("HH:mm") : ""}
                    `
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && dataMeeting.length > 0,
                    component: <div className="flex justify-center items-center">
                        <OptionsButtonCustom
                            enableView
                            onViewClick={() => {
                                window.open(`${routeName.cms.MeetingCaledarDetail.replace(":id", id_meeting_room)}?mode=VIEW`, "_blank");
                            }}
                        />
                    </div>
                },

            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    // MEETING

    const handleGetLog = useCallback(async (id_complaints: number) => {
        let query: logComplaintType = {
            page: page,
            limit: pageLimit
        }
        dispatch(setLoading());
        await ComplaintApi.getLog(id_complaints, query).then((res) => {
            if (res.status < 300) {
                set_data_time_line(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit])
    // SUBMIT

    const generateForm = (): complaintCreateFront => {
        return {
            complaints_date: null,
            complaints_desc: formState.complaint_detail,
            complaints_subject: formState.complaint_title,
            email: formState.email,
            first_name: formState.first_name,
            last_name: formState.last_name,
            passport: formState.id_card,
            id_complaints_type: id_complaints_type?.id_complaints_type,
            id_faculty: formState.id_faculty || null,
            is_public: formState.is_publish,
            phone: formState.phone_number,
            student_no: formState.employee_no,
            // id_position: formState.id_position || null

        }
    }
    const handleApproveAndRejectInfer = (id_complaints: number, mode: "APPROVE" | "REJECT") => {
        alertActive(mode === 'APPROVE' ? t("COMPLAINTS_APPROVE") : t("COMPLAINTS_SEND_REVIEW"), mode === 'APPROVE' ? t("COMPLAINTS_CONFIRM_APPROVE") : t("COMPLAINTS_CONFIRM_SEND_REVIEW"), undefined, undefined, async () => {
            const body: updateStatusBack = {
                complaints_result: mode === 'APPROVE' ? "" : remark,
                complaints_status: mode === 'APPROVE' ? COMPLAINTS_STATUS.APPROVE : COMPLAINTS_STATUS.SEND_FOR_REVIEW
            }
            dispatch(setLoading());
            await ComplaintApi.updateStatusBack(id_complaints, body).then((res) => {
                if (res.status < 300) {
                    handleCloseModal();
                    alertSuccess(mode === 'APPROVE' ? t("COMPLAINTS_APPROVE") : t("COMPLAINTS_SEND_REVIEW"), mode === 'APPROVE' ? t("COMPLAINTS_APPROVED") : t("COMPLAINTS_SENT_FOR_REVIEW"))
                    handleGetDetail(id_complaints)
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })

        })
    }
    const handleSendMeeting = (id_complaints: number) => {
        alertActive(t("COMPLAINTS_SCHEDULE_MEETING"), t("COMPLAINTS_CONFIRM_MEETING"), t("COMPLAINTS_MEETING"), undefined, async () => {
            const body: updateStatusBack = {
                complaints_result: "",
                complaints_status: COMPLAINTS_STATUS.APPOINT_MEETING
            }
            dispatch(setLoading());
            await ComplaintApi.updateStatusBack(id_complaints, body).then((res) => {
                if (res.status < 300) {
                    const queryParams = new URLSearchParams({
                        meeting_room_name: dataDetail?.complaints_subject || "",
                        meeting_room_desc: dataDetail?.complaints_desc || "",
                        id_complaints: dataDetail?.id_complaints
                    }).toString();
                    handleGetDetail(id_complaints);
                    alertSuccess(t("COMPLAINTS_SCHEDULE_MEETING"), t("COMPLAINTS_MEETING_SUCCESS"), undefined, () => {
                        window.open(`${routeName.cms.MeetingCaledarCreate}?${queryParams}`, "_blank");
                    });
                }
            }).catch((err) => console.log(err)).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleGetMeeting = useCallback(async (id_complaints: number) => {
        let query: meetingComplaints = {
            page: pageMeeting,
            limit: pageLimitMeeting
        }

        await ComplaintApi.getMeetingList(id_complaints, query).then((res) => {
            if (res.status < 300) {
                const data_list: any[] = res.data?.data?.items || [];
                setDataMeeting(data_list);
                setTotalItemsMeeting(res.data?.data?.meta?.totalItems || 0);
            }
        })
    }, [pageMeeting, pageLimitMeeting])


    const handleSubmitInfer = async (id_complaints: number) => {
        const body: updateStatusBack = {
            complaints_result: remark,
            complaints_status: COMPLAINTS_STATUS.WAIT_APPROVE
        }
        await handleUploadImageFileInfer(id_complaints)
        await ComplaintApi.updateStatusBack(id_complaints, body).then((res) => {
            if (res.status < 300) {
                alertSuccess(t("COMPLAINTS_SUMMARY_RESULT"), t("COMPLAINTS_SUMMARY_SUCCESS"));
                handleGetDetail(id_complaints);
                handleCloseModal();
            }
        }).catch((err) => {
            console.log(err)
            alertError(t("COMPLAINTS_SUMMARY_RESULT"), t("COMPLAINTS_SUMMARY_FAILED"))
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleSubmit = async (mode: "DRAFT" | "SUBMIT") => {
        const body = generateForm();
        if (id) {
            if (complaint_data_old?.length !== complaints_files?.length) {
                await handleDeleteFile()
            }
            await handleUploadImageFile(+id);
            dispatch(setLoading());
            await ComplaintApi.updateOne(+id, body).then(async (res) => {
                if (res.status < 300) {
                    if (mode === 'SUBMIT') {
                        // ส่งเรื่องร้องเรียน กรณีอัพเดต
                        await ComplaintApi.updateStatus(+id, {
                            complaints_status: COMPLAINTS_STATUS.SUBMIT_COMPLAINT
                        }).then((res) => {
                            if (res.status < 300) {
                                navigate(routeName.students.complaintSubmit);
                                alertSuccess(t("COMPLAINTS_SUBMIT_COMPLAINT"), t('COMPLAINTS_SUBMITTED_SUCCESS'));
                            }
                        })
                    } else {
                        alertSuccess(t("COMPLAINTS_UPDATE_SUBMIT_LIST"), t("COMPLAINTS_UPDATE_SUBMIT_LIST_SUCCESS"));
                        handleGetDetail(+id);
                    }
                }
            }).catch((err) => {
                alertError(t("COMPLAINTS_UPDATE_SUBMIT_LIST"), t("COMPLAINTS_UPDATE_SUBMIT_LIST_FAILED"))
                throw err
            }).finally(() => {
                set_image_data([]);
                dispatch(unsetLoading());
            })
        } else {
            if (mode === 'SUBMIT') {
                alertActive(t("COMPLAINTS_CONFIRM_SUBMIT_WITH_SAVE"), t("COMPLAINTS_CONFIRM_SUBMIT_WITH_SAVE_FULL"), t("COMPLAINTS_SUBMIT_COMPLAINT"), undefined, async () => {
                    await ComplaintApi.createFront(body).then(async (res) => {
                        if (res.status < 300) {
                            const id_complaints = res.data?.data?.id_complaints;
                            await handleUploadImageFile(+id_complaints);
                            // ส่งเรื่องร้องเรียน กรณีสร้างใหม่
                            await ComplaintApi.updateStatus(+id_complaints, {
                                complaints_status: COMPLAINTS_STATUS.SUBMIT_COMPLAINT
                            }).then((res) => {
                                if (res.status < 300) {
                                    navigate(routeName.students.complaintSubmit);
                                    alertSuccess(t("COMPLAINTS_SUBMIT_COMPLAINT"), t("COMPLAINTS_SUBMITTED_SUCCESS"));
                                }
                            })

                        }
                    }).catch((err) => {
                        alertError(t("COMPLAINTS_CREATE_COMPLAINT_LIST"), t("COMPLAINTS_CREATE_SUBMIT_LIST_FAILED"))
                        console.log(err)
                    })
                })
            } else {
                await ComplaintApi.createFront(body).then(async (res) => {
                    if (res.status < 300) {
                        const id_complaints = res.data?.data?.id_complaints;
                        // ส่งเรื่องร้องเรียน กรณีสร้างใหม่
                        await handleUploadImageFile(+id_complaints);
                        alertSuccess(t("COMPLAINTS_CREATE_COMPLAINT_LIST"), t("COMPLAINTS_CREATE_SUBMIT_LIST_SUCCESS"));
                        if (id_complaints) {
                            setTimeout(() => {
                                window.location.replace(routeName.students.complaintSubmitDetail.replace(":id", id_complaints))
                            }, 500)
                        } else {
                            navigate(routeName.students.complaintSubmit)
                        }
                    }
                }).catch((err) => {
                    alertError(t("COMPLAINTS_CREATE_COMPLAINT_LIST"), t("COMPLAINTS_CREATE_SUBMIT_LIST_FAILED"))
                    console.log(err)
                })
            }
        }

    }
    useEffect(() => {
        if (id && !isNaN(+id) && show_time_line) {
            handleGetLog(+id);
        }
    }, [handleGetLog, show_time_line])
    useEffect(() => {
        if (id && !isNaN(+id)) {
            handleGetDetail(+id);
        }
    }, [])
    useEffect(() => {
        handleGetComplaintType();
    }, [])
    useEffect(() => {
        if (id && !isNaN(+id)) {
            handleGetMeeting(+id);
        }
    }, [handleGetMeeting])
    useEffect(() => {
        if (profile) {
            handleGetData(id)
        }
    }, [profile])

    return {
        handleChangeFormState,
        formState,
        handleSubmit,
        group_data,
        profile,
        handleChangeImage,
        status,
        image_data,
        step,
        set_step,
        id_complaints_type,
        set_id_complaints_type,
        complaint_type_data,
        complaints_files,
        handleDeleteImageUploadFile,
        handleDeleteImageApi,
        handleGetFile,
        dataDetail,
        show_time_line,
        set_show_time_line,


        page,
        pageLimit,
        handleRequestSort,
        setPage,
        setPageLimit,
        sortType,
        sortBy,
        totalItems,
        headCells,
        data_time_line,
        renderData,
        handleOpenModal,
        handleCloseModal,

        handleChangeImageInfer,
        file_infer,
        file_infer_api,
        remark,
        set_remark,
        handleSubmitInfer,
        handleGetDetail,
        handleApproveAndRejectInfer,
        handleSendMeeting,
        handleDeleteImageUploadFileInfer,
        handleDownloadFile,


        pageMeeting,
        pageLimitMeeting,
        setPageMeeting,
        setPageLimitMeeting,
        handleRequestSortMeeting,
        sortByMeeting,
        sortTypeMeeting,
        dataMeeting,
        renderDataMeeting,
        headCellsMeeting,
        totalItemsMeeting

    }
}
